import {
  ListBoxItem,
  ResourcePickerPopover,
  SelectTrigger,
} from "@jugl-web/ui-kit";
import { VoiceFilterValue } from "../../../../types";

export interface VoiceAgentVoiceFilterOption<T extends string> {
  id: VoiceFilterValue<T>;
  label: string;
}

export interface VoiceAgentVoiceFilterProps<T extends string> {
  value: VoiceFilterValue<T>;
  options: VoiceAgentVoiceFilterOption<T>[];
  isDisabled?: boolean;
  onChange: (value: VoiceFilterValue<T>) => void;
}

export const VoiceAgentVoiceFilter = <T extends string>({
  value,
  options,
  isDisabled,
  onChange,
}: VoiceAgentVoiceFilterProps<T>) => {
  const items: ListBoxItem<VoiceAgentVoiceFilterOption<T>>[] = options.map(
    (option) => ({
      id: option.id,
      value: option,
    })
  );

  const selectedLabel =
    options.find((option) => option.id === value)?.label || options[0]?.label;

  return (
    <ResourcePickerPopover
      key={value}
      placement="bottom-end"
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          ref={triggerRef}
          as={SelectTrigger}
          label={
            <div className="flex items-center gap-1.5">
              {value !== "all" && (
                <div className="mx-1 h-2.25 w-2.25 rounded-full bg-primary" />
              )}
              <span className="text-sm">{selectedLabel}</span>
            </div>
          }
          hasValue
          isOpen={isOpen}
          isDisabled={isDisabled}
          className="h-8 w-fit max-w-full"
        />
      )}
      items={items}
      selectionBehavior={{ mode: "single", canToggle: false }}
      defaultSelectedIds={[value]}
      maxVisibleItems={8}
      itemSize="md"
      spaceBetweenItems="compact"
      renderLabel={(item) => item.value.label}
      onSelect={({ item, onClose }) => {
        onChange(item.value.id);
        onClose();
      }}
    />
  );
};
